var path = 'machines/common/Pages/detail/commission/index.html';
var html = "<ui-view></ui-view>\r\n\r\n\r\n\r\n\r\n\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;